import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import Radio from '@material-ui/core/Radio'
import styles from './styles'
import data from './data'
import clsx from 'clsx'
import { track } from '@amplitude/analytics-browser'
const StyledRadio = withStyles({
  root: {
    '&$checked': {
      color: '#015FFB',
    },
    padding: 0,
  },
  checked: {},
})(props => <Radio color="default" {...props} />)

const Selections = props => {
  const { classes, creationType, setCreationType } = props

  const handleClickOnBadge = item => {
    track('creation_type_selected', { creation_type: item.title })
    setCreationType(item.id)
  }

  return (
    <div className={classes.root}>
      {data.map(item => (
        <div
          className={clsx({
            [classes.root_content]: creationType !== item.id,
            [classes.root_content_selected]: creationType == item.id,
          })}
          key={item.id}
          onClick={() => handleClickOnBadge(item)}
          style={{
            border:
              creationType == item.id
                ? '1px solid #015FFB'
                : '1px solid #E0E0E0',
            backgroundColor: creationType == item.id ? '#E3F3FF' : '#fff',
          }}
        >
          <div>
            <StyledRadio
              checked={creationType == item.id}
              name="radio-button-demo"
              inputProps={{ 'aria-label': 'A' }}
            />
          </div>

          <div className={classes.root_content_text}>
            <Typography className={classes.root_content_text_title}>
              {item.title}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  )
}

export default withStyles(styles)(Selections)
